﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_customEventPushList from './tpl/customEventPushList.html';
import View_CustomEventPushListItem from './customEventPushListItem';

export default Marionette.CollectionView.extend({
    tagName: 'customEventPushList',
    childViewContainer: '#customEventPushList',
    childView: View_CustomEventPushListItem,
    getTemplate: function () {
        return tpl_customEventPushList();
    },
    initialize: function () {
        this.app = this.options.app;
    },
    buildChildView: function(child, ChildViewClass, childViewOptions){
        var options = _.extend({model: child}, childViewOptions);
        options.app = this.app;
        options.localSetting = this.options.localSetting;
        var view = new ChildViewClass(options);
        return view;
    }
});
